import React from "react";
import PropTypes from "prop-types";
import IcomoonReact from "icomoon-react";
import iconSet from "./selection.json";
var IconMoon = function (props) {
    var color = props.color, size = props.size, icon = props.icon, className = props.className, _a = props.padding, padding = _a === void 0 ? "5px" : _a;
    return (React.createElement(IcomoonReact, { className: className, iconSet: iconSet, color: color, size: size, icon: icon, style: { padding: padding } }));
};
IconMoon.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
IconMoon.defaultProps = {
    className: "",
    color: "",
    size: "100%"
};
export default IconMoon;
